import React, { useEffect, useRef } from "react";
import "../styles/alumniWorkedAt.css";

const companies = [
  { name: "Genpact", logo: "/images/logos/genpact.png" },
  { name: "Jindal Group", logo: "/images/logos/jindal.png" },
  { name: "Beeta Logistics", logo: "/images/logos/betalogic.png" },
  { name: "Airtel", logo: "/images/logos/airtel.png" },
  { name: "Accenture", logo: "/images/logos/accenture.png" },
  { name: "Birla Group", logo: "/images/logos/birla.png" },
];

export default function AlumniWorkedAt() {
  const sliderRef = useRef(null);

  const scroll = (dir = 1) => {
    const slider = sliderRef.current;
    if (!slider) return;

    const cardWidth = slider.children[0].offsetWidth + 24;
    slider.scrollBy({ left: cardWidth * dir, behavior: "smooth" });
  };

  /* AUTO LOOP */
  useEffect(() => {
    const slider = sliderRef.current;
    if (!slider) return;

    const interval = setInterval(() => {
      const maxScroll = slider.scrollWidth - slider.clientWidth;
      if (slider.scrollLeft >= maxScroll - 5) {
        slider.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        scroll(1);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <section className="alumni-section">
      <div className="alumni-header">
        <h2>
          Our Alumni <span>Worked At</span>
        </h2>

        <div className="alumni-nav">
          <button onClick={() => scroll(-1)}>‹</button>
          <button onClick={() => scroll(1)}>›</button>
        </div>
      </div>

      <div className="alumni-slider-wrapper">
        <div className="alumni-slider" ref={sliderRef}>
          {companies.map((c, i) => (
            <div key={i} className="alumni-card">
              <img src={c.logo} alt={c.name} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
